"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _select = _interopRequireDefault(require("../../select"));
var _icon = _interopRequireDefault(require("../../icon"));
var _Searchable = _interopRequireDefault(require("../Searchable"));
var _Function = _interopRequireDefault(require("../Function"));
var _button = require("../../button");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var getInteractionData = function getInteractionData(operator, value) {
  switch (operator) {
    case '<':
      return {
        max: value,
        min: null,
        isInclusive: false
      };
    case '>':
      return {
        min: value,
        max: null,
        isInclusive: false
      };
    case '<=':
      return {
        max: value,
        min: null,
        isInclusive: true
      };
    case '>=':
      return {
        min: value,
        max: null,
        isInclusive: true
      };
    default:
      return {};
  }
};
var thresholdOperators = [{
  value: '<',
  label: '<'
}, {
  value: '>',
  label: '>'
}, {
  value: '<=',
  label: '<='
}, {
  value: '>=',
  label: '>='
}];
var BlockWrapper = function BlockWrapper(_ref) {
  var data = _ref.data,
    blockData = _ref.blockData,
    blockType = _ref.blockType,
    interactionType = _ref.interactionType,
    actions = _ref.actions,
    labels = _ref.labels,
    thresholdIndex = _ref.thresholdIndex,
    errors = _ref.errors,
    disabled = _ref.disabled,
    ruleIndex = _ref.ruleIndex,
    isFocused = _ref.isFocused,
    thresholds = _ref.thresholds,
    thresholdRowIndex = _ref.thresholdRowIndex,
    andData = _ref.andData,
    clearFocus = _ref.clearFocus;
  var bockSeparator = function bockSeparator() {
    /*#__PURE__*/_react["default"].createElement("span", null, "and");
  };
  if (!interactionType) return '';
  if (interactionType === 'between') {
    return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, isFocused && /*#__PURE__*/_react["default"].createElement(_button.Button, {
      disabled: disabled,
      className: "formula-button delete-member",
      onMouseDown: function onMouseDown(ev) {
        var morphedData = R.clone(thresholds);
        ev.stopPropagation();
        morphedData.thresholdRows[thresholdRowIndex] = _objectSpread(_objectSpread({}, morphedData.thresholdRows[thresholdRowIndex]), {}, {
          max: null,
          min: null,
          isBetween: false,
          isInclusive: false
        });
        actions.thresholdChange('update', {
          thresholdIndex: thresholdIndex,
          thresholdData: morphedData
        });
        clearFocus();
      },
      type: "naked"
    }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
      icon: "ion-android-delete",
      size: 16
    })), /*#__PURE__*/_react["default"].createElement(_Function["default"], {
      disabled: disabled,
      keysPath: [],
      className: "threshold-element",
      value: labels.FORMULA_BETWEEN_FUNCTION_HEADER_LABEL,
      ruleIndex: 0,
      args: [[blockData.min], [blockData.max]],
      labels: {},
      renderMember: function renderMember(_ref2) {
        var keysPath = _ref2.keysPath,
          member = _ref2.member;
        return /*#__PURE__*/_react["default"].createElement(_Searchable["default"], {
          isFocused: isFocused,
          disabled: disabled,
          key: keysPath.join('-'),
          id: "".concat(ruleIndex, "-threshold-between-function-").concat(thresholdRowIndex, "-").concat(thresholdIndex, "-").concat(keysPath.join('-')),
          keysPath: [],
          description: R.prop('description', member),
          error: R.path(['thresholdRows', thresholdRowIndex, keysPath[1] === 0 ? 'min' : 'max'], errors),
          labels: labels,
          formulaChange: function formulaChange(update) {
            var ruleThresholds = R.clone(data);
            ruleThresholds.thresholdRows[thresholdRowIndex][keysPath[1] === 0 ? 'min' : 'max'] = update;
            actions.thresholdChange('update', {
              thresholdIndex: thresholdIndex,
              thresholdData: ruleThresholds
            });
          },
          displayName: R.prop('displayName', member),
          value: R.prop('value', member),
          searchableAction: actions.getFormulaOperandValues,
          isFullWidth: false
        });
      },
      index: 0,
      formulaChange: function formulaChange() {},
      separator: function separator() {
        return bockSeparator();
      }
    }), isFocused && blockType !== 'and' && !andData && /*#__PURE__*/_react["default"].createElement(_button.Button, {
      disabled: disabled,
      className: "formula-button add-member",
      onMouseDown: function onMouseDown(ev) {
        var morphedData = R.clone(thresholds);
        ev.stopPropagation();
        morphedData.thresholdRows.push({
          field: 'age',
          min: null,
          max: null,
          date: null
        });
        actions.thresholdChange('update', {
          thresholdIndex: thresholdIndex,
          thresholdData: morphedData
        });
        clearFocus();
      },
      type: "naked"
    }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
      icon: "ion-plus",
      size: 16
    })));
  }
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
    className: "threshold-element"
  }, /*#__PURE__*/_react["default"].createElement(_select["default"], {
    disabled: disabled,
    id: "".concat(ruleIndex, "-threshold-select-").concat(blockType, "-").concat(thresholdIndex),
    placeholder: "",
    className: "formula-operator",
    onChange: function onChange(update) {
      var ruleThresholds = R.clone(data);
      ruleThresholds.thresholdRows[thresholdRowIndex].operator = update.value;
      if (ruleThresholds.thresholdRows[thresholdRowIndex].member && ruleThresholds.thresholdRows[thresholdRowIndex].operator) {
        ruleThresholds.thresholdRows[thresholdRowIndex] = _objectSpread(_objectSpread({}, ruleThresholds.thresholdRows[thresholdRowIndex]), getInteractionData(ruleThresholds.thresholdRows[thresholdRowIndex].operator, ruleThresholds.thresholdRows[thresholdRowIndex].member));
      }
      actions.thresholdChange('update', {
        thresholdIndex: thresholdIndex,
        thresholdData: ruleThresholds
      });
    },
    errors: R.path(['thresholdRows', thresholdRowIndex, 'operator'], errors),
    options: thresholdOperators,
    value: blockData.operator,
    searchable: false
  })), /*#__PURE__*/_react["default"].createElement(_Searchable["default"], {
    isFocused: isFocused,
    disabled: disabled,
    id: "".concat(ruleIndex, "-threshold-searchable-").concat(blockType, "-").concat(thresholdIndex),
    type: "variable",
    keysPath: [],
    description: R.path(['member', 'description'], blockData),
    labels: labels,
    formulaChange: function formulaChange(update) {
      var ruleThresholds = R.clone(data);
      ruleThresholds.thresholdRows[thresholdRowIndex].member = update;
      if (ruleThresholds.thresholdRows[thresholdRowIndex].member && ruleThresholds.thresholdRows[thresholdRowIndex].operator) {
        ruleThresholds.thresholdRows[thresholdRowIndex] = _objectSpread(_objectSpread({}, ruleThresholds.thresholdRows[thresholdRowIndex]), getInteractionData(ruleThresholds.thresholdRows[thresholdRowIndex].operator, ruleThresholds.thresholdRows[thresholdRowIndex].member));
      }
      actions.thresholdChange('update', {
        thresholdIndex: thresholdIndex,
        thresholdData: ruleThresholds
      });
    },
    displayName: R.path(['member', 'displayName'], blockData),
    error: R.path(['thresholdRows', thresholdRowIndex, 'member'], errors),
    value: R.path(['member', 'value'], blockData),
    searchableAction: actions.getFormulaOperandValues,
    isFullWidth: false
  }));
};
BlockWrapper.defaultProps = {
  errors: {},
  disabled: false,
  blockType: '',
  interactionType: '',
  isFocused: false,
  andData: undefined
};
BlockWrapper.propTypes = {
  disabled: _propTypes["default"].bool,
  /* The threshold index */
  thresholdIndex: _propTypes["default"].number.isRequired,
  /* The rule index */
  ruleIndex: _propTypes["default"].number.isRequired,
  /* The thresholdRowIndex index */
  thresholdRowIndex: _propTypes["default"].number.isRequired,
  /* The rewards labels */
  labels: _propTypes["default"].objectOf(_propTypes["default"].string).isRequired,
  /* The store function update */
  clearFocus: _propTypes["default"].func.isRequired,
  /* The root data for each threshold */
  data: _propTypes["default"].shape({}).isRequired,
  /* The block data for each threshold (if - and) */
  blockData: _propTypes["default"].shape({
    min: _propTypes["default"].number,
    max: _propTypes["default"].number,
    operator: _propTypes["default"].string
  }).isRequired,
  /* The block data for each threshold (if - and) */
  andData: _propTypes["default"].shape({}),
  /* The errros object */
  errors: _propTypes["default"].shape({}),
  actions: _propTypes["default"].objectOf(_propTypes["default"].func).isRequired,
  /* The root thresholds for each threshold */
  thresholds: _propTypes["default"].shape({}).isRequired,
  blockType: _propTypes["default"].string,
  interactionType: _propTypes["default"].string,
  isFocused: _propTypes["default"].bool
};
BlockWrapper.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "BlockWrapper",
  "props": {
    "errors": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": false
    },
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "blockType": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "interactionType": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "isFocused": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "andData": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": false
    },
    "thresholdIndex": {
      "description": "",
      "type": {
        "name": "number"
      },
      "required": true
    },
    "ruleIndex": {
      "description": "",
      "type": {
        "name": "number"
      },
      "required": true
    },
    "thresholdRowIndex": {
      "description": "",
      "type": {
        "name": "number"
      },
      "required": true
    },
    "labels": {
      "description": "",
      "type": {
        "name": "objectOf",
        "value": {
          "name": "string"
        }
      },
      "required": true
    },
    "clearFocus": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "data": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": true
    },
    "blockData": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "min": {
            "name": "number",
            "required": false
          },
          "max": {
            "name": "number",
            "required": false
          },
          "operator": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": true
    },
    "actions": {
      "description": "",
      "type": {
        "name": "objectOf",
        "value": {
          "name": "func"
        }
      },
      "required": true
    },
    "thresholds": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": true
    }
  }
};
var _default = BlockWrapper;
exports["default"] = _default;